import React, { useState } from 'react'
import {
  PASSWORD_RESET_ERROR_MESSAGE,
  PASSWORD_RESET_MESSAGE,
  PASSWORD_RESET_TITLE,
  REQUEST_PASSWORD_ACTION,
  RETURN_TO_LOGIN,
} from '../../constants/ui.labels'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import CheckEmail from '../../components/CheckEmail'
import NavbarButton from '../../components/NavbarButton'
import NoRecaptchaSecureForm from '../../components/NoRecaptchaSecureForm'
import PasswordResetForm from '../../components/PasswordResetForm'
import SecureForm from '../../components/SecureForm'
import ContentHeader from '../../components/ContentHeader'
import Error from '../../components/Error'
import { LOGIN_ROOT } from '../../constants/routes'
import { isAutomationAccount } from '../../config/feature-flags'
import { navigateTo } from 'mfa'

const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

const PasswordReset = ({
  processed,
  error,
  siteKey,
  disabledForm,
  onSubmit,
  onExecuteRecaptcha,
}) => {
  const [email, setEmail] = useState('')
  const [isValid, setIsValid] = useState(false)

  const handleEmailChange = ({ target }) => {
    const { value } = target
    setEmail(value)
    setIsValid(isValidEmail(value))
  }

  const handleFormSubmit = (recaptchaResponse) => {
    onSubmit({ email, recaptchaResponse })
  }

  return (
    <AccountRecoveryBase.Centered
      navbarActionElement={
        <NavbarButton
          action={() => navigateTo(LOGIN_ROOT)}
          actionMessage={RETURN_TO_LOGIN}
        />
      }
    >
      {!processed ? (
        <React.Fragment>
          <ContentHeader
            title={PASSWORD_RESET_TITLE}
            message={PASSWORD_RESET_MESSAGE}
          />
          <Error message={error ? PASSWORD_RESET_ERROR_MESSAGE : null} />
          <PasswordResetForm
            onEmailValidation={isValidEmail}
            email={email}
            onEmailChange={handleEmailChange}
            disabledForm={disabledForm}
          />
          {isAutomationAccount() ? (
            <NoRecaptchaSecureForm
              isFormValid={isValid}
              disabledForm={disabledForm}
              submitLabel={REQUEST_PASSWORD_ACTION}
              onSubmit={handleFormSubmit}
            />
          ) : (
            <SecureForm
              isFormValid={isValid}
              siteKey={siteKey}
              disabledForm={disabledForm}
              submitLabel={REQUEST_PASSWORD_ACTION}
              onSubmit={handleFormSubmit}
              onExecuteRecaptcha={onExecuteRecaptcha}
            />
          )}
        </React.Fragment>
      ) : (
        <CheckEmail />
      )}
    </AccountRecoveryBase.Centered>
  )
}

export default PasswordReset
